
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-network",
      function () {
        return require("private-next-pages/community-network.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-network"])
      });
    }
  